import { render } from "./ProfileModels.vue?vue&type=template&id=7368e231"
import script from "./ProfileModels.vue?vue&type=script&lang=js"
export * from "./ProfileModels.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__